import template from './denomination.create.html';
import controller from './denomination.create.controller';
import './denomination.create.controller';

let denominationcreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default denominationcreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/denomination/create/denomination.create.component.js